import { FilesEditUploader } from "@/entities";
import { Panel, PanelHeader, PanelBody } from "@/shared";

interface Props {
  panelTitle: string;
  queryKey: string;
  table: string;
  column: string;
  id: string;
  timestamp: string;
  files: any[];
  accept?: string;
}
export function AdminCommonFileFilesEdit({
  panelTitle,
  queryKey,
  table,
  column,
  id,
  timestamp,
  files,
  accept,
}: Props) {
  return (
    <Panel queryKey={queryKey}>
      <PanelHeader>{panelTitle}</PanelHeader>
      <PanelBody className="p-0">
        <FilesEditUploader
          queryKey={queryKey}
          table={table}
          column={column}
          id={id}
          timestamp={timestamp}
          files={files}
          accept={accept}
        />
      </PanelBody>
    </Panel>
  );
}
